import React, { useState } from "react";

import {
    Avatar,
    Typography
} from "@mui/material";

import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Swal from "sweetalert2";
import api, { BASE_URL } from "../api/api";
import defaultAvatar from "../Dashboard/maleee.jpg";
import { Link } from 'react-router-dom';
import { Button } from "antd";


const ParentAndStudentProfile = ({
    user,
    refreshUser,
    tempImage,
    setTempImage,
    theme,
    darkMode
}) => {


const [overlay,setOverlay] = useState(false);



const token =
localStorage.getItem(
    "access"
);




const handleImageChange = async(e)=>{


const file =
e.target.files[0];


if(!file)
return;



const formData =
new FormData();



formData.append(
    "profile_image",
    file
);




setTempImage(
    URL.createObjectURL(file)
);



setOverlay(true);



try{


await api.put(
    "/user-profile/",
    formData,
    {

    headers:{

        Authorization:
        `Bearer ${token}`,

        "Content-Type":
        "multipart/form-data"

    }

    }

);




Swal.fire(
    "Success",
    "Profile image updated!",
    "success"
);



setOverlay(false);



refreshUser();



}
catch(error){


console.error(
    "Image update error",
    error
);



setOverlay(false);



setTempImage(null);



Swal.fire(
    "Failed",
    "Could not update profile image",
    "error"
);



}


};





return (

<div
style={{

background:
darkMode
?
"linear-gradient(135deg,#1e293b,#0f172a)"
:
"linear-gradient(135deg,#ffffff,#f8fafc)",


borderRadius:22,

padding:18,

textAlign:"center",

border:
`1px solid ${theme.border}`,


boxShadow:
"0 12px 30px rgba(0,0,0,.08)"

}}
>




<div
style={{

position:"relative",

width:90,

height:90,

margin:"auto"

}}
>




<Avatar

src={

tempImage

||

(

user?.profile_image

?

`${BASE_URL}${user.profile_image}`

:

defaultAvatar

)

}

sx={{

width:90,

height:90,

border:"4px solid #800000",

boxShadow:
"0 8px 25px rgba(128,0,0,.25)",

opacity:
overlay
?
0.5
:
1

}}

/>





<input

type="file"

accept="image/*"

id="parent-profile-upload"

style={{

display:"none"

}}

onChange={handleImageChange}

/>





<label

htmlFor="parent-profile-upload"

style={{

position:"absolute",

bottom:0,

right:0,

width:32,

height:32,

borderRadius:"50%",

background:"#800000",

display:"flex",

alignItems:"center",

justifyContent:"center",

cursor:"pointer",

boxShadow:
"0 5px 15px rgba(0,0,0,.25)"

}}

>



<CameraAltIcon

sx={{

fontSize:18,

color:"#fff"

}}

/>



</label>



</div>






<Typography

style={{

marginTop:12,

fontWeight:800,

fontSize:15,

color:theme.text

}}

>

{
user?.username || "Parent"
}

</Typography>







<Typography

style={{

fontSize:12,

color:theme.secondary

}}

>

{
user?.email
}

</Typography>







<div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
  }}
>
  <Typography
    style={{
      fontSize: 11,
      marginTop: 5,
      padding: "4px 12px",
      display: "inline-block",
      borderRadius: 20,
      background: "#800000",
      color: "#fff",
      fontWeight: 700,
    }}
  >
    {user?.user_type}
  </Typography>

  <Link
    to="/chatApp"
    style={{
      textDecoration: "none",
    }}
  >
    <Button type="primary">
      Chats
    </Button>
  </Link>
</div>

</div>

);


};


export default ParentAndStudentProfile;